export enum PushTriggerModeEnum {
    NON_PARALLEL = "non-parallel",
    PARALLEL = "parallel",
}
